import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, DotsCircleHorizontalIcon, ExclamationCircleIcon, BanIcon, ExternalLinkIcon } from '@heroicons/react/outline';
import { WorkflowAutomationItem } from '../interfaces';

function SalesforceItemRow(props: { item: WorkflowAutomationItem }) {
  const { item } = props;
  const { t } = useTranslation();

  let icon = <DotsCircleHorizontalIcon className="flex-shrink-0 w-5 h-5 text-blue" />;
  let label = t("In progress");

  if (item.status === "COMPLETED") {
    icon = <CheckCircleIcon className="flex-shrink-0 w-5 h-5 text-green" />;
    label = t("Completed");
  } else if (item.status === "COMPLETED_WITH_ERROR") {
    icon = <ExclamationCircleIcon className="flex-shrink-0 w-5 h-5 text-yellow" />;
    label = t("Completed with errors");
  } else if (item.status === "CANCELLED") {
    icon = <BanIcon className="flex-shrink-0 w-5 h-5 text-gray-400" />;
    label = t("Cancelled");
  } else if (item.stage === "REVIEW_PENDING") {
    label = t("Awaiting review");
  } else if (item.stage === "SIGNATURES_PENDING") {
    label = t("Awaiting signatures");
  }

  return (
    <a
      className="flex items-center gap-2 p-2 border border-gray-200 rounded-md hover:bg-blue-50 group"
      href={`${process.env.PUBLIC_URL}/w/${item.workflow.id}/outputs/${item.id}`}
      target="_blank"
      rel="noreferrer"
    >
      {icon}
      <div className="flex flex-col min-w-0">
        <div className="text-sm font-semibold text-gray-700 truncate font-gilroy">{item.workflow.name}</div>
        <div className="text-xs text-gray-500">{label} · {moment(item.createdAt).fromNow()}</div>
      </div>
      <ExternalLinkIcon className="flex-shrink-0 w-4 h-4 ml-auto text-gray-400 group-hover:text-blue" />
    </a>
  );
}

export default SalesforceItemRow;
